/**
 * Supprime le préfixe linguistique d'une URL pour permettre une comparaison indépendante de la langue.
 * Transforme "/en/explorer" en "/explorer", "/fr/explorer" en "/explorer", etc.
 * @param {string} url - L'URL à normaliser
 * @returns {string} L'URL sans préfixe linguistique
 */
export const removeLanguagePrefixFromUrl = (url) => {
  if (!url) return ''

  try {
    const urlObj = new URL(url, window.location.origin)
    let pathname = urlObj.pathname

    // Supprimer les préfixes linguistiques (2 caractères après le premier slash)
    pathname = pathname.replace(/^\/[a-z]{2}\b/, '')

    // S'assurer qu'on a au moins un '/' au début
    if (!pathname.startsWith('/')) {
      pathname = '/' + pathname
    }

    return pathname
  } catch {
    // Si l'URL n'est pas valide, essayer de nettoyer directement
    return url.replace(/^\/[a-z]{2}\b/, '') || '/'
  }
}
